// extracted by css-extract-rspack-plugin
export default {"aside":"Aside-module__aside___Z3_Zz","asideItem":"Aside-module__asideItem___puS6s","text":"Aside-module__text___OjCHz"};